import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FleetRouter from "./Fleet/FleetRouter";
import InventoryRouter from "./Inventory/InventoryRouter";
import TechniciansPage from "./Technicians/TechniciansPage";
import SopsPage from "./Sops/SopsPage";
import KnowledgePage from "./Sops/KnowledgePage";
import OfficePage from "./Office/OfficePage";
import DocumentsPage from "./Documents/DocumentsPage";

/* Operations — running the business: SOPs, documents (contracts, waivers,
   checklists; industry library), technicians as a schedule resource,
   fleet, inventory. People management is Team (the directory + the one
   employee card + time off / training / compliance / onboarding). The old
   /operations/roster and /operations/time-off routes redirect there so nothing
   bookmarked dies. */
export default function OperationsRouter() {
  return (
    <Routes>
      <Route path="office" element={<OfficePage />} />
      <Route path="sops" element={<SopsPage />} />
      <Route path="knowledge" element={<KnowledgePage />} />
      <Route path="documents" element={<DocumentsPage />} />
      <Route path="technicians" element={<TechniciansPage />} />
      <Route path="fleet/*" element={<FleetRouter />} />
      <Route path="inventory/*" element={<InventoryRouter />} />
      <Route path="roster" element={<Navigate to="/team" replace />} />
      <Route path="roster/:id" element={<Navigate to="/team" replace />} />
      <Route path="time-off" element={<Navigate to="/team/time-off" replace />} />
      <Route path="compliance" element={<Navigate to="/team/compliance" replace />} />
      <Route index element={<Navigate to="office" replace />} />
    </Routes>
  );
}
